import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { orderItemRepository } from '../data-access/repositories/OrderItemRepository'
import { type OrderItemRecurrenceDurationEnum } from '../entities/enums/OrderItemRecurrenceDurationEnum'
import { type OrderItemRecurrenceFrequencyEnum } from '../entities/enums/OrderItemRecurrenceFrequencyEnum'

const base = ['order-item']

export const orderItemQueryConfig = {
  getPurchasingListItems: () => ({
    queryKey: buildQueryKey([...base, 'purchasing-list']),
    queryFn: () => orderItemRepository.getPurchasingListItems(),
  }),

  // Plain array (not buildQueryKey): productUrl can be undefined and must
  // remain part of the key rather than being truncated.
  extractProductData: (productUrl?: string) => ({
    queryKey: [...base, 'extract-data', productUrl],
  }),

  // Plain array (not buildQueryKey): params can be undefined and must remain
  // part of the key rather than being truncated.
  getRecurrencePeriodCount: (params?: {
    duration: OrderItemRecurrenceDurationEnum
    durationQuantity: number
    frequency: OrderItemRecurrenceFrequencyEnum
    startDate: string
  }) => ({
    queryKey: [...base, 'recurrence', 'period-count', params],
  }),

  getAccountCodeSuggestions: (departmentId: number) => ({
    queryKey: buildQueryKey([
      ...base,
      'account-code-suggestions',
      departmentId,
    ]),
  }),

  getPreferredVendorSuggestions: () => ({
    queryKey: buildQueryKey([...base, 'preferred-vendor-suggestions']),
  }),
}
